<template>
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0">
      <ChromeSpeechToTextTextarea rows="4" max-rows="10" v-model="text" />
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 check-text-right"
    >
      <v-btn v-if="$route.query.testToken" @click="testToken">testToken</v-btn>
      <ConfirmationDialog
        certificate
        headerClass="modal-header"
        message-title="FINALIZAR?"
        :message-body="`Deseja realmente finalizar a evolução?`"
        open-text="FINALIZAR MANUAL COM ASSINATURA ELETRÔNICA"
        open-class="btn-notcertified"
        open-left-icon="fa-check"
        @yes="finish"
        :loading="loading"
        :disabled="loading"
      />
    </div>
  </div>
</template>

<script>
import ChromeSpeechToTextTextarea from "../Components/ChromeSpeechToTextTextarea";

import ConfirmationDialog from "../Components/ConfirmationDialog";

import ErrorsMessages from "../Components/ErrorsMessages";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import BRyHUB from "../../lib/BRy/hub";

export default {
  name: "Create",

  components: {
    ChromeSpeechToTextTextarea,
    ConfirmationDialog,
    ErrorsMessages,
  },

  props: {
    resident_id: [String, Number],
    type: [String, Number],
  },

  data() {
    return {
      text: "",
      loading: false,
      errors: [],
    };
  },

  methods: {
    async testToken() {
      await api.post("/certificate/test-token");
    },

    async finish() {
      try {
        this.loading = true;

        const { resident_id, text, type } = this;

        let execute_certificate = false;

        if (
          this.$router.currentRoute.query.execute_certificate &&
          this.$router.currentRoute.query.execute_certificate == "execute"
        ) {
          execute_certificate = "execute";
        }

        let params = {
          execute_certificate,
          resident_id,
          text,
          type,
        };

        const response = await api.post("/rest-home/evolution", params);

        const { error, errors, message, id } = response.data;

        if (!error) {
          toast(message, "success");
          this.$bvModal.hide("modalCreate");
          this.$emit("success");
          this.text = "";
          this.errors = [];

          await BRyHUB.authorize({ id, table: "evolution" });
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
